import {
    FETCH_ASSETSHARECLASS_BEGIN,
    FETCH_ASSETSHARECLASS_SUCCESS,
    FETCH_ASSETSHARECLASS_FAILURE,

    FETCH_ASSETSHARECLASSDETAILS_BEGIN,
    FETCH_ASSETSHARECLASSDETAILS_SUCCESS,
    FETCH_ASSETSHARECLASSDETAILS_FAILURE,

    FETCH_ASSETSHARECLASSFEEDETAILS_BEGIN,
    FETCH_ASSETSHARECLASSFEEDETAILS_SUCCESS,
    FETCH_ASSETSHARECLASSFEEDETAILS_FAILURE
    } from '../constants/assetShareclass';
    

const initialState={
    assetShareClass:[],
    shareClassData:[],
    shareClassFeeData:[],
    isLoading:false,
    error:""
}


//Asset ShareClass

export const getAssetShareclassReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETSHARECLASS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETSHARECLASS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                assetShareClass: payload.assetShareClass
            };
        case FETCH_ASSETSHARECLASS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
//Asset ShareClass Details

export const getAssetShareclassDetailsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETSHARECLASSDETAILS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETSHARECLASSDETAILS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                shareClassData: payload.shareClassData
            };
        case FETCH_ASSETSHARECLASSDETAILS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}

export const getAssetShareclassFeeDetailsReducer = (state = initialState, action) => {
    const { type, payload } = action;
    switch (type) {
        case FETCH_ASSETSHARECLASSFEEDETAILS_BEGIN: {
            return {
                ...initialState,
                isLoading: true,
                error: null,
            };
        }
        case FETCH_ASSETSHARECLASSFEEDETAILS_SUCCESS:
            return {
                ...initialState,
                isLoading: false,
                shareClassFeeData: payload.shareClassFeeData
            };
        case FETCH_ASSETSHARECLASSFEEDETAILS_FAILURE:
            return {
                ...initialState,
                error: payload.error,
                isLoading: true,
            };
        default:
            return state;
    }
}
